import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  haltedMessageText: {
    id: 'frontbucket.pipelines.components.haltedMessage.text',
    description:
      'The text of the halted pipeline message. The "another pipeline" link text is wrapped in <linkOne> tags. The deployment environment name placeholder is wrapped in <linkTwo> tags.',
    defaultMessage:
      'This pipeline was halted because <linkOne>another pipeline</linkOne> was deploying to <linkTwo>{deploymentEnvironment}</linkTwo>.',
  },
  haltedMessageLearnMore: {
    id: 'frontbucket.pipelines.components.haltedMessage.learnMore',
    description: 'Learn more of the halted pipeline message',
    defaultMessage: 'Learn more',
  },
  manualHaltedStep: {
    id: 'frontbucket.pipelines.components.haltedMessage.manual',
    description: 'Manual halted step message',
    defaultMessage:
      ' A change request is pending for this deployment. The change request must be completed before deploying to this environment.',
  },
  automaticalHaltedStep: {
    id: 'frontbucket.pipelines.components.haltedMessage.automatical.halted',
    description: 'Automatical halted step message',
    defaultMessage:
      'A change request is pending for this deployment. When the change request is complete, the deployment will automatically resume.',
  },
  automaticalPausedMessage: {
    id: 'frontbucket.pipelines.components.haltedMessage.automatical.paused',
    description: 'Automatical paused message',
    defaultMessage:
      'This pipeline was automatically paused, and can be manually resumed. {reason} {isDeploymentConcurrencyReason}',
  },
  deploymentGateFailedReason: {
    id: 'frontbucket.pipelines.components.haltedMessage.deploymentGate.failed',
    description: 'Deployment gate failed reason message',
    defaultMessage:
      'This pipeline was halted because something went wrong when creating a change request in Jira. Resume the step to try again.',
  },
  branchHasNoDeploymentPermissionsReason: {
    id: 'frontbucket.pipelines.components.haltedMessage.branch.noDeployment.permissions',
    description:
      'Branch has no deployment permissions reason. The deployment environment name placeholder is wrapped in <link> tags. The {isBranchPipeline} value selects between two variants: a branch-pipeline variant that names {sourceBranch}, or a generic permitted-branch variant.',
    defaultMessage:
      'This pipeline was halted because <link>{deploymentEnvironment}</link>  {isBranchPipeline, select, true {can not be deployed to from the {sourceBranch} branch.} other {can only be deployed to from permitted branch pipelines.}}',
  },
  userHasNoDeploymentPermissionsReason: {
    id: 'frontbucket.pipelines.components.haltedMessage.user.noDeployment.permissions',
    description:
      'User has no deployment permissions reason. The actor display name placeholder is wrapped in <linkOne> tags. The deployment environment name placeholder is wrapped in <linkTwo> tags.',
    defaultMessage:
      'This pipeline was halted because <linkOne>{actorDisplayName}</linkOne> tried to deploy, but only an admin can deploy to <linkTwo>{deploymentEnvironment}</linkTwo>.',
  },
  allowanceExceededReasonPartOne: {
    id: 'frontbucket.pipelines.components.haltedMessage.allowanceExceeded.reasonOne',
    description: 'allowance exceeded reason message part one',
    defaultMessage:
      "This pipeline was halted because you've reached your monthly minutes quota.",
  },
  allowanceExceededReasonPartTwo: {
    id: 'frontbucket.pipelines.components.haltedMessage.allowanceExceeded.reasonTwo',
    description: 'allowance exceeded reason message part two',
    defaultMessage:
      "You won't be able to run new steps until next month or unless you update your quota.",
  },
  // https://www.atlassian.com/legal/acceptable-use-policy
  acceptableUsePolicyBreachedReasonPartOne: {
    id: 'frontbucket.pipelines.components.haltedMessage.acceptableUsePolicyBreached.reasonOne',
    description: 'admin halted step reason message part one',
    defaultMessage:
      "This pipeline was halted due to a breach of Atlassian's Acceptable Use Policy.",
  },
  acceptableUsePolicyBreachedReasonPartTwo: {
    id: 'frontbucket.pipelines.components.haltedMessage.acceptableUsePolicyBreached.reasonTwo',
    description:
      'Admin halted step reason message part two. The "contact our support team" link text is wrapped in <link> tags.',
    defaultMessage:
      'If you believe this was a mistake, <link>contact our support team</link> for assistance.',
  },
  viewAcceptableUsePolicy: {
    id: 'frontbucket.pipelines.components.haltedMessage.acceptableUsePolicy.details',
    description: 'View Acceptable Use Policy message',
    defaultMessage: 'Acceptable Use Policy',
  },
  viewPlanDetails: {
    id: 'frontbucket.pipelines.components.haltedMessage.plan.details',
    description: 'View plan details message',
    defaultMessage: 'View plan details',
  },
  agenticPipelinesNotEnabledReason: {
    id: 'frontbucket.pipelines.components.haltedMessage.agenticPipelinesNotEnabled.reasonOne',
    description:
      'Message shown when a pipeline step was halted because Agentic Pipelines are not enabled for the workspace',
    defaultMessage:
      "This pipeline was halted because Agentic Pipelines aren't enabled for this workspace.",
  },
  enableAgenticPipelines: {
    id: 'frontbucket.pipelines.components.haltedMessage.agenticPipelinesNotEnabled.enable',
    description:
      'Link text to navigate to workspace settings for Agentic Pipelines',
    defaultMessage: 'Go to workspace settings',
  },
  agenticQuotaExceededReason: {
    id: 'frontbucket.pipelines.components.haltedMessage.agenticQuotaExceeded.reasonOne',
    description:
      'Message shown when a pipeline step was halted because the agentic pipelines quota has been exceeded',
    defaultMessage:
      "This pipeline was halted because you've reached your Agentic Pipelines quota.",
  },
  agenticPipelinesProviderNotEnabledReason: {
    id: 'frontbucket.pipelines.components.haltedMessage.agenticPipelinesProviderNotEnabled.reasonOne',
    description:
      'Message shown when a pipeline step was halted because a 3P CLI provider was not enabled in Agentic Pipelines settings for the workspace',
    defaultMessage:
      "This pipeline was halted because {providerName} isn't enabled for this workspace.",
  },
  enableProviderAgenticPipelines: {
    id: 'frontbucket.pipelines.components.haltedMessage.agenticPipelinesProviderNotEnabled.enable',
    description:
      'Link text to navigate to workspace settings for Agentic Pipelines 3P CLI provider configuration',
    defaultMessage: 'Enable {providerName}',
  },
});
